import type { TextSectionType } from "./types";

type TextSectionProps = TextSectionType;

export default function TextSection({ body, header }: TextSectionProps) {
  return (
    <section className="pt-12.5 md:pt-20">
      <h3 className="mx-auto mb-5 max-w-201 text-center font-semibold text-24 text-white leading-[1.25em] md:mb-7.5 md:text-36">
        {header}
      </h3>
      <p className="text-14/[1.7em] text-pale-lavender md:text-16/[2em]">
        {body}
      </p>
    </section>
  );
}
